"use strict";

($dt => {
	
	$dt.blocks['login-or-signup'] = {
		
		/**
		 * This is called for each block matching this type
		 * @param {HTMLElement} container 
		 */
		LoadBlock: container => {
			const [ forgotPWButton, forgotPWOverlay, forgotPWClose ] = [
				container.querySelector('.forgot-pw a'),
				container.querySelector('.forgot-pw-wrapper'),
				container.querySelector('.forgot-pw-wrapper .close-btn')
			];

			if (forgotPWButton) {
				forgotPWButton.addEventListener('click', () => {
					forgotPWOverlay.classList.add('active');
				});
				
				forgotPWClose.addEventListener('click', () => {
					forgotPWOverlay.classList.remove('active');
				});

				$dt.forms.Login.RegisterOnSuccessEvent(() => {
					forgotPWButton.style.display = 'none';
				});
			}
		}
		
	};
	
})(window.d3_wp_themejs);
